import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Button,
    Grid,
} from 'semantic-ui-react';
import { useAuth } from '../providers';

export default function Login() {
    const { authenticated, login } = useAuth();
    const history = useHistory();
    const location = useLocation();

    const from = location.state?.from || "/";

    const handleLogin = async () => {
        try {
            await login();
            history.push(from)
        } catch (err) { }
    };

    useEffect(() => {
        if (authenticated) {
            history.push(from);
        }
    }, [authenticated, history, from])

    return (
        <React.Fragment>
            <Grid textAlign='center' style={{ height: '35vh' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450 }}>
                    <p>
                        <strong style={{ color: '#fff' }}>Please login to Twitch with continue.</strong>
                    </p>
                    <Button onClick={handleLogin} style={{ color: '#fff', backgroundColor: '#9146FF' }} fluid size='large'>
                        <i class="icon twitch"></i>
                        Login with Twitch
                    </Button>
                </Grid.Column>
            </Grid>
        </React.Fragment>
    );
}
